import { defineComponent as _defineComponent } from 'vue'
import VPagination from "~/components/VPagination/index.vue";
import SortList from "~/components/cruise-calendar/sort-list.vue";

// import { watchDebounced } from "@vueuse/core";

import type { GetCalendarCruiseListData } from "~/services/model/calendar";
import { computed, useStore } from "@nuxtjs/composition-api";


export default /*#__PURE__*/_defineComponent({
  __name: 'product-list',
  props: {
    param: { default: () => ({}) },
    sortType: null,
    sortName: null,
    title: { default: "" },
    date: null,
    sortFieldName: null,
    sortOrderName: null,
    listData: null,
    pageIndex: null
  },
  emits: ["page-change"],
  setup(__props: any, { emit }: { emit: ({
  (name: "page-change", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { param: Record<string, any>, sortType: "asc" | "desc", sortName: string, title: string, date: string, sortFieldName?: string, sortOrderName?: string, listData: GetCalendarCruiseListData, pageIndex: number }

// import { ref, useFetch } from "@nuxtjs/composition-api";
// import { useCruiseCalendarCruiseList } from "~/composables/cruise-calendar";
// import { toValue } from "~/composables/toValue";




const sorts = [
  { value: "2", label: "价格排序" },
  { value: "7", label: "天数排序" },
];

const store = useStore();
const isDistributor = computed(() => store.getters.isDistributor);
const product_list = computed(()=>{
  console.log(props)
  return [...props.listData.top_list,...props.listData.list];
})

return { __sfc: true,props, emit, sorts, store, isDistributor, product_list, VPagination, SortList }
}

})